import { initialState } from '../../../components/providers/store-provider/state.context';

import { IAction } from '../root/i-action';
import { IState } from '../root/state.interface';
import { IUser } from './i-user';
import { IAuth, IAuthType } from './i-auth';
import { IRole } from './i-role';
import { IPermission } from './i-permission';

export const getAuthTypeRequest = (state: IState): IState => ({
  ...state,
  authType: {
    data: null,
    loading: true,
    loaded: false,
    error: undefined,
  },
});

export const getAuthTypeSuccess = (state: IState, action: IAction<IAuthType>): IState => ({
  ...state,
  authType: {
    data: action.payload,
    loading: false,
    loaded: true,
    error: undefined,
  },
});

export const getAuthTypeFailure = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  authType: {
    data: null,
    loading: false,
    loaded: true,
    error: action.payload,
  },
});

export const signInRequest = (state: IState): IState => ({
  ...state,
  auth: {
    data: {
      user_id: null,
      accessToken: null,
      accessTokenExpiry: null,
      tenant: '',
    },
    loading: true,
    error: undefined,
  },
});

export const signInSuccess = (state: IState, action: IAction<IAuth>): IState => ({
  ...state,
  auth: {
    data: action.payload,
    loading: true,
    error: undefined,
  },
});

export const signInFailure = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  auth: {
    data: {
      user_id: null,
      accessToken: null,
      accessTokenExpiry: null,
      tenant: '',
    },
    loading: false,
    error: action.payload,
  },
});

export const permissionsRequest = (state: IState): IState => ({
  ...state,
  permission: {
    data: [],
    loading: true,
    loaded: false,
    error: undefined,
  },
});

export const permissionsSuccess = (state: IState, action: IAction<IPermission[]>): IState => ({
  ...state,
  permission: {
    data: action.payload,
    loading: false,
    loaded: true,
    error: undefined,
  },
});

export const permissionsFailure = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  permission: {
    data: [],
    loading: false,
    loaded: false,
    error: action.payload,
  },
});

export const logoutSuccess = (): IState => ({
  ...initialState,
});

export const getCurrentUserRequest = (state: IState): IState => ({
  ...state,
  currentUser: {
    data: {
      id: 0,
      role_id: 0,
      tenant: '',
      name: '',
      firstname: '',
      lastname: '',
      email: '',
      group_code: '',
      createdTime: '',
    },
    loading: true,
    error: undefined,
    loaded: false,
  },
});

export const getCurrentUserSuccess = (state: IState, action: IAction<IUser>): IState => ({
  ...state,
  currentUser: {
    data: action.payload,
    loading: false,
    loaded: true,
    error: undefined,
  },
});

export const getCurrentUserFailure = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  currentUser: {
    data: {
      id: 0,
      role_id: 0,
      tenant: '',
      name: '',
      firstname: '',
      lastname: '',
      email: '',
      group_code: '',
      createdTime: '',
    },
    loading: false,
    error: action.payload,
    loaded: false,
  },
});

export const getPickedUserRequest = (state: IState): IState => ({
  ...state,
  pickedUser: {
    data: {
      id: 0,
      role_id: 0,
      tenant: '',
      name: '',
      firstname: '',
      lastname: '',
      email: '',
      group_code: '',
      createdTime: '',
      timeZone: '',
    },
    loading: true,
    error: undefined,
  },
});

export const getPickedUserSuccess = (state: IState, action: IAction<IUser>): IState => ({
  ...state,
  pickedUser: {
    data: action.payload,
    loading: false,
    error: undefined,
  },
});

export const getPickedUserFailure = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  pickedUser: {
    data: {
      id: 0,
      role_id: 0,
      tenant: '',
      name: '',
      firstname: '',
      lastname: '',
      email: '',
      group_code: '',
      createdTime: '',
      timeZone: '',
    },
    loading: false,
    error: action.payload,
  },
});

export const getUsersListStart = (state: IState): IState => ({
  ...state,
  users: {
    data: [],
    loading: true,
    error: undefined,
  },
});

export const getUsersListFail = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  users: {
    data: [],
    loading: false,
    error: action.payload,
  },
});

export const getUsersListSuccess = (state: IState, action: IAction<IUser[]>): IState => ({
  ...state,
  users: {
    data: action.payload,
    loading: false,
    error: undefined,
  },
});

export const getRolesListRequest = (state: IState): IState => ({
  ...state,
  roles: {
    data: [],
    loading: true,
    error: undefined,
  },
});

export const getRolesListSuccess = (state: IState, action: IAction<IRole[]>): IState => ({
  ...state,
  roles: {
    data: action.payload,
    loading: false,
    error: undefined,
  },
});

export const getRolesListFail = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  roles: {
    data: [],
    loading: false,
    error: action.payload,
  },
});

export const resetPassRequest = (state: IState): IState => ({
  ...state,
  auth: {
    data: {
      user_id: null,
      accessToken: null,
      accessTokenExpiry: null,
      tenant: '',
    },
    loading: true,
    error: undefined,
  },
});

export const resetPassSuccess = (state: IState): IState => ({
  ...state,
  auth: {
    data: state.auth.data,
    loading: false,
    error: undefined,
  },
});

export const resetPassFailure = (state: IState): IState => ({
  ...state,
  auth: {
    data: state.auth.data,
    loading: false,
    error: 'Something went wrong',
  },
});

export const forgotPassRequest = (state: IState): IState => ({
  ...state,
  auth: {
    data: {
      user_id: null,
      accessToken: null,
      accessTokenExpiry: null,
      tenant: '',
    },
    loading: true,
    error: undefined,
  },
});

export const forgotPassSuccess = (state: IState): IState => ({
  ...state,
  auth: {
    data: state.auth.data,
    loading: false,
    error: undefined,
  },
});

export const forgotPassFailure = (state: IState): IState => ({
  ...state,
  auth: {
    data: state.auth.data,
    loading: false,
    error: 'Something went wrong',
  },
});

export const timeZonesRequest = (state: IState): IState => ({
  ...state,
  timeZones: {
    data: [],
    loading: true,
    loaded: false,
    error: undefined,
  },
});

export const timeZonesSuccess = (state: IState, action: IAction<string[]>): IState => ({
  ...state,
  timeZones: {
    data: action.payload,
    loading: false,
    loaded: true,
    error: undefined,
  },
});

export const timeZonesFail = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  timeZones: {
    data: [],
    loading: false,
    loaded: false,
    error: action.payload,
  },
});

export const changeForgottenPasswordRequest = (state: IState): IState => ({
  ...state,
  forgottenPasswordChange: {
    data: false,
    loading: true,
    loaded: false,
    error: undefined,
  },
});

export const changeForgottenPasswordSuccess = (state: IState): IState => ({
  ...state,
  forgottenPasswordChange: {
    data: true,
    loading: false,
    loaded: true,
    error: undefined,
  },
});

export const changeForgottenPasswordFail = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  forgottenPasswordChange: {
    data: false,
    loading: false,
    loaded: true,
    error: action.payload,
  },
});
export const permissionRequest = (state: IState): IState => ({
  ...state,
  permission: {
    data: [],
    loading: true,
    error: undefined,
  },
});

export const permissionSuccess = (state: IState, action: IAction<IPermission[]>): IState => ({
  ...state,
  permission: {
    data: action.payload,
    loading: true,
    error: undefined,
  },
});

export const permissionFailure = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  permission: {
    data: [],
    loading: false,
    error: action.payload,
  },
});
